import dayjs from 'dayjs'

import 'dayjs/locale/pt-br'

dayjs.locale('pt-br')

export default (context, inject) => {
  context.$dayjs = dayjs
  inject('dayjs', dayjs)
}
